import React from "react";

function MainText() {
  return (
    <div className="lg:w-[62rem] font-athiti text-sm lg:text-2xl text-center">
      <p>
        Herzlich willkommen in unserem Ferienhaus in Carolinensiel.
        <br /> Bei uns findest Du ein gemütliches Refugium, um einen entspannten
        Urlaub an der <br className="hidden lg:inline" />
        ostfriesischen Küste zu verbringen. Von dem zentral und doch sehr ruhig
        gelegenen Haus kannst Du in fünfzehn Minuten den Ortskern von
        Carolinensiel erreichen, oder Du besuchst den Strand in Harlesiel, der
        per Pedes ebenfalls nur eine Viertelstunde entfernt ist.
        <br />
        Mit dem Fahrrad bist Du natürlich noch etwas schneller unterwegs, außer
        Du machst einen kleinen
        <br className="hidden lg:inline" /> Umweg und besuchst die Schafe auf
        den Deichen, wo Du nicht nur einen grandiosen Blick
        <br className="hidden lg:inline" />
        über das Watt genießen, sondern ordentlich Sonne tanken oder Dir den
        Wind um <br className="hidden lg:inline" />
        die Nase wehen lassen kannst.
      </p>
    </div>
  );
}

export default MainText;
